export const global_height_breakpoint_2xl = {
  "name": "--pf-v5-global--height-breakpoint--2xl",
  "value": "80rem",
  "var": "var(--pf-v5-global--height-breakpoint--2xl)"
};
export default global_height_breakpoint_2xl;